import { createSlice } from "@reduxjs/toolkit";

const topNavSlice = createSlice({
    name: "topnav",
    initialState: {
        breadcrumb: [],
        showNewReport: true,
        showDownload: false,
        showDelete: false,
    },
    reducers: {
        setNavBredcrumb: (state, { payload }) => {
            state.breadcrumb = payload;
        },
        setNavNewReportBtn: (state, { payload }) => {
            state.showNewReport = payload;
        },
        setNavDownloadBtn: (state, { payload }) => {
            state.showDownload = payload;
        },
        setNavDeleteBtn: (state, { payload }) => {
            state.showDelete = payload;
        },
    }
});

export const { setNavBredcrumb, setNavDeleteBtn, setNavDownloadBtn, setNavNewReportBtn } = topNavSlice.actions;

export default topNavSlice.reducer;